import url from './urls'

const state = {
  isLoading: false,
  categorys: null,
  subcategory: null,
  detail: null
}

const mutations = {
  GETCATE (state) {
    state.isLoading = true
    state.categorys = null

    fetch(url.archive.category)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.categorys = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETLIST (state, id) {
    state.isLoading = true
    state.subcategory = null

    fetch(url.archive.subCategory + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.subcategory = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETDETAIL (state, idAndCateId) {
    state.isLoading = true
    state.detail = []

    fetch(url.archive.content + idAndCateId.id + `?subcat=${idAndCateId.categoryId}`)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.detail = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  getCate ({ commit }) {
    commit('GETCATE')
  },

  getList ({ commit }, id) {
    commit('GETLIST', id)
  },

  getDetail ({ commit }, idAndCateId) {
    commit('GETDETAIL', idAndCateId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
